import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { pxToRem } from '../../../../lib';
import getBorderFocusStyles from '../../getBorderFocusStyles';
import TreeTitle from '../../../../components/Tree/TreeTitle';
var treeItemStyles = {
  root: function root(_ref) {
    var siteVariables = _ref.theme.siteVariables,
        p = _ref.props;
    return Object.assign({
      listStyleType: 'none',
      padding: "0 0 0 ".concat(pxToRem(1 + (p.level - 1) * 10))
    }, getBorderFocusStyles({
      siteVariables: siteVariables
    })[':focus'], {
      ':focus-visible': _defineProperty({
        outline: 0
      }, "> .".concat(TreeTitle.className), Object.assign({
        position: 'relative'
      }, getBorderFocusStyles({
        siteVariables: siteVariables
      })[':focus-visible']))
    });
  }
};
export default treeItemStyles;